export default __webpack_public_path__ + "static/media/villarrica-full-lake-view.23343f7d.jpg";